export default __webpack_public_path__ + "static/media/neuroborncats_full_press_kit.7f298646.zip";